import React from 'react';

interface BookingStatusBadgeProps {
  status: 'pending' | 'confirmed' | 'cancelled' | 'no_show' | 'completed';
  size?: 'default' | 'small';
  /** Only show badge for pending status (hide confirmed, completed, etc.) */
  pendingOnly?: boolean;
}

const BookingStatusBadge: React.FC<BookingStatusBadgeProps> = ({ status, size = 'default', pendingOnly = false }) => {
  // If pendingOnly mode, only show badge for pending status
  if (pendingOnly && status !== 'pending') {
    return null;
  }
  const getStatusStyles = () => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'confirmed':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'completed':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'cancelled':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'no_show':
        return 'bg-gray-100 text-gray-800 border-gray-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case 'pending':
        return 'Pending';
      case 'confirmed':
        return 'Confirmed';
      case 'completed':
        return 'Completed';
      case 'cancelled':
        return 'Cancelled';
      case 'no_show':
        return 'No Show';
      default:
        return status;
    }
  };

  const sizeClasses = size === 'small' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-0.5 text-xs';

  return (
    <span
      className={`inline-flex items-center ${sizeClasses} rounded-full font-medium border ${getStatusStyles()}`}
    >
      {getStatusLabel()}
    </span>
  );
};

export default BookingStatusBadge;
